// extracted by mini-css-extract-plugin
module.exports = {"imgix":"dq"};